import { render } from "./PayyoRefundStatusBadge.vue?vue&type=template&id=f5fdc49a"
import script from "./PayyoRefundStatusBadge.vue?vue&type=script&lang=js"
export * from "./PayyoRefundStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__